import React, { SVGProps } from 'react';

export const CrossIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg role="none" width="53" height="53" viewBox="0 0 53 53" {...props} xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" strokeLinecap="round" stroke="currentColor" strokeWidth="4">
      <path d="M50.5 2.5L2.107 50.893M2.5 2.5l48.393 48.393" />
    </g>
  </svg>
);
